import {
    ROOT_URL,
} from "./actions-index";
import axios from "axios/index";

export function fetchPlayersByName(name) {
    return function (dispatch) {
        return new Promise((resolve, reject) => {
            axios.get(`${ROOT_URL}/player-list-search?fullNameSearch=${name}`)
            .then(response => {
                if (response) {
                    resolve(response.data);
                } else {
                    console.log(`fan error occurred while fetching /player-list-search?fullNameSearch=${name}`);
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/actions-players.js